import cx from "classnames";
import { Component } from "react";
import GoogleTagDataLayer from "../GoogleTagDataLayer/GoogleTagDataLayer";
import "./SegmentedControl.scss";
export type SegmentedTabType = {
  id?: string;
  title: any;
  callback: (...args: Array<any>) => any;
  isActive: boolean;
  googleTagClickId: any;
  dlvEventName: any;
};
type Props = {
  className?: any;
  tabs: SegmentedTabType[];
  disableFilterTab?: boolean;
  tabTypes: any;

  /** Set to true, if the active tab should have a transparent bg */
  transparent?: boolean;
};

class SegmentedControl extends Component<Props> {
  render(): null | Element<"div"> {
    const { tabs, className, disableFilterTab, tabTypes, transparent } =
      this.props;

    if (tabs == null) {
      return null;
    }

    let tabTypeArray: Record<string, any>;
    if (tabTypes == null) return null;
    else {
      // BET-3223 add tabs as ids for QA automation
      tabTypeArray = Object.keys(tabTypes).map(key => {
        return [tabTypes[key]];
      });
    }

    return (
      <div
        className={cx("segmented-control", className, {
          "disable-filter-tab": disableFilterTab,
        })}
      >
        {tabs.map((tab, index) => (
          // When using the SegmentedControl component we can pass a googleTagId and a EventName
          // this will then be passed to the GoogleTagDataLayer component so that
          // Google tag Manager can have access to them and use them to track clicks etc */
          <GoogleTagDataLayer
            key={tab.id ?? index} // Prefer tab.id if available, else fallback to index
            googleTagClickId={tab.googleTagClickId}
            dlvEventName={tab.dlvEventName}
          >
            <div
              id={`${tabTypeArray[index]}`}
              className={cx("segmented-control__tab", {
                "segmented-control__tab--active": tab.isActive,
                "segmented-control__tab--transparent": transparent,
              })}
              onClick={tab.callback}
            >
              {tab.title}
            </div>
          </GoogleTagDataLayer>
        ))}
      </div>
    );
  }
}

export default SegmentedControl;
